export const item_status = [
  { id: 1, value: "ACTIVE", label: "Activo" },
  { id: 2, value: "CANCELED", label: "Cancelado" },
  { id: 3, value: "FINISHED", label: "Finalizado" },
]

export const parsed_body_to_send = (_data: any) => {
  const { status, items, initDate, endDate, baseScheduleDate, stockDate, channel } = _data

  let data = items?.map((item: any) => {
    return {
      ...item,
      custom: {
        ...item.custom,
        isPresale: Boolean(status === "ACTIVE"),
        presale: {
          status,
          initDate,
          endDate,
          baseScheduleDate,
          stockDate,
          channels: channel,
        },
      },
    }
  })

  return data
}

export const fill_form_from_data = (_item: any) => {
  let initDate = _item?.custom?.presale?.initDate || ""
  let endDate = _item?.custom?.presale?.endDate || ""
  let baseScheduleDate = _item?.custom?.presale?.baseScheduleDate || ""
  let stockDate = _item?.custom?.presale?.stockDate || ""
  let channel = _item?.custom?.presale?.channels || []

  let data = {
    status: _item?.custom?.isPresale ? "ACTIVE" : "CANCELED",
    items: [_item],
    initDate,
    endDate,
    baseScheduleDate,
    stockDate,
    channel,
  }

  return data
}
